module.exports = __webpack_public_path__ + "img/help_img.c71cd610.png";